import { CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js';

export const getUserAttributes = (
    cognitoUser: CognitoUser,
): Promise<Error | TrqkUserAttributes> =>
    new Promise((resolve, reject) => {
        cognitoUser.getUserAttributes(
            (
                err: Error | undefined,
                attributes: CognitoUserAttribute[] | undefined,
            ) => {
                let statementId = null as Maybe<string>;
                let trqkUserId = null as Maybe<string>;
                let name = null as Maybe<string>;
                let username = null as Maybe<string>;
                let email = null as Maybe<string>;

                if (err) {
                    reject(err);
                }

                if (attributes) {
                    attributes.forEach(
                        (attribute: CognitoUserAttribute): void => {
                            if (
                                // The custom attribute is titled 'custom:statement_url' for legacy
                                // reasons; it's actually the statement_id.
                                attribute.getName() === 'custom:statement_url'
                            ) {
                                statementId = attribute.getValue();
                            }
                            if (attribute.getName() === 'custom:trqkUserId') {
                                trqkUserId = attribute.getValue();
                            }
                            if (attribute.getName() === 'name') {
                                name = attribute.getValue();
                            }
                            if (attribute.getName() === 'email') {
                                // Unfortunately, we don't have access to a `username` property
                                // here, so we are using the email as the username. This assumption
                                // is hard-coded in several places, including here.
                                username = attribute.getValue();
                                email = attribute.getValue();
                            }
                        },
                    );
                }

                resolve({
                    email,
                    name,
                    statementId,
                    trqkUserId,
                    username,
                });
            },
        );
    });
